"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconNewWindow', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4.66666 3.5V9.33333H12V3.5H4.66666ZM2.66666 1.66667C2.66666 0.746192 3.41285 0 4.33332 0H12.3333C13.2538 0 14 0.746192 14 1.66667V9.66667C14 10.5871 13.2538 11.3333 12.3333 11.3333H11.3333V12.3333C11.3333 13.2538 10.5871 14 9.66667 14H1.66667C0.746192 14 0 13.2538 0 12.3333V4.33333C0 3.41286 0.746192 2.66667 1.66667 2.66667H2.66666V1.66667ZM9.33333 12V11.3333H4.33332C3.41285 11.3333 2.66666 10.5871 2.66666 9.66667V4.66667H2V12H9.33333Z'],
  params: {
    height: '14',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M5.55556 4V12.4444H16V4H5.55556ZM3.55556 1.88889C3.55556 0.845684 4.40124 0 5.44445 0H16.1111C17.1543 0 18 0.845684 18 1.88889V12.5556C18 13.5988 17.1543 14.4444 16.1111 14.4444H14.4444V16.1111C14.4444 17.1543 13.5988 18 12.5556 18H1.88889C0.845684 18 0 17.1543 0 16.1111V5.44445C0 4.40124 0.845684 3.55556 1.88889 3.55556H3.55556V1.88889ZM12.4444 16V14.4444H5.44445C4.40124 14.4444 3.55556 13.5988 3.55556 12.5556V5.55556H2V16H12.4444Z'],
  params: {
    height: '18',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M6.44444 5V15.4444C6.44444 15.5058 6.49419 15.5556 6.55555 15.5556H19.8889C19.9503 15.5556 20 15.5058 20 15.4444V5H6.44444ZM6.55555 0C5.38962 0 4.44444 0.945177 4.44444 2.11111V4.44444H2.11111C0.945177 4.44444 0 5.38962 0 6.55555V19.8889C0 21.0548 0.945177 22 2.11111 22H15.4444C16.6104 22 17.5556 21.0548 17.5556 19.8889V19.8807L17.5174 17.5556H19.8889C21.0548 17.5556 22 16.6104 22 15.4444V2.11111C22 0.945177 21.0548 0 19.8889 0H6.55555ZM15.5172 17.5556H6.55555C5.38962 17.5556 4.44444 16.6104 4.44444 15.4444V6.44444H2.11111C2.04975 6.44444 2 6.49419 2 6.55555V19.8889C2 19.9503 2.04975 20 2.11111 20H15.4444C15.5045 20 15.5534 19.9524 15.5555 19.8928L15.5172 17.5556Z'],
  params: {
    height: '22',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M26 6L7.77778 6V19.7778C7.77778 20.0232 7.97676 20.2222 8.22222 20.2222H25.5556C25.801 20.2222 26 20.0232 26 19.7778V6ZM8.22222 0C6.87219 0 5.77778 1.09441 5.77778 2.44444V5.77778H2.44444C1.09441 5.77778 0 6.87219 0 8.22222V25.5556C0 26.9056 1.09441 28 2.44444 28H19.7778C21.1278 28 22.2222 26.9056 22.2222 25.5556V22.2222H25.5556C26.9056 22.2222 28 21.1278 28 19.7778V2.44444C28 1.09441 26.9056 0 25.5556 0H8.22222ZM20.2222 22.2222H8.22222C6.87219 22.2222 5.77778 21.1278 5.77778 19.7778V7.77778H2.44444C2.19898 7.77778 2 7.97676 2 8.22222V25.5556C2 25.801 2.19898 26 2.44444 26H19.7778C20.0232 26 20.2222 25.801 20.2222 25.5556V22.2222Z'],
  params: {
    height: '28',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;